import { Pipe, PipeTransform, NgModule } from "@angular/core";

@Pipe({
    name: "persoImgSrc",
})
export class ProductImagePersoUrlPipe implements PipeTransform {
    public transform(url: string, size: number): string | undefined {
        if (!url) {
            return undefined;
        }
        const urlModified = new URL(url);
        urlModified.searchParams.set("size", size.toString());
        return urlModified.toString();
    }
}

@NgModule({
    declarations: [ProductImagePersoUrlPipe],
    exports: [ProductImagePersoUrlPipe],
    providers: [ProductImagePersoUrlPipe],
})
export class ProductImagePersoUrlPipeModule {}
